import React, { Fragment } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Agreement = ({ setShowAgreement }) => {
  return (
    <Fragment>
      <div className="agreement-overlay">
        <div className="agreement-box">
          <i
            className="far fa-times-circle green fa-3x subscription-x"
            onClick={() => setShowAgreement(false)}
          ></i>
          <div className="flex-center">
            <p className="agreement-title green">Welcome to ime!</p>
          </div>
          <div className="center-paragraph">
            <p className="toa-guidelines white">
              By accessing and using this website, users acknowledge that they
              have read, understood, and agreed to abide by our Terms of
              Agreement and Community Guidelines. These terms and guidelines are
              put in place to ensure a safe, respectful, and enjoyable
              experience for all users.
              <br />
              <br /> Additionally, this website uses cookies to enhance user
              experience and collect data about site usage. By continuing to use
              the website, users consent to the use of cookies. Continued use of
              the website signifies acceptance of any updates or modifications
              to these terms, which will be posted on the website from time to
              time. If users do not agree with any part of the Terms of
              Agreement or Community Guidelines, they are advised to discontinue
              use of the website immediately. For detailed information, please
              review our{" "}
              <Link to="/agreement">
                <span className="green bold mx-5 cursor">
                  Terms of Agreement
                </span>
              </Link>
              and{" "}
              <Link to="/agreement">
                <span className="green bold mx-5 cursor">
                  Community Guidelines
                </span>
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Agreement;
